const currencyInput = {
  inserted(el) {
    const input = el.querySelector('input')
    if (!input) {
      return
    }
    const handler = e => {
      let value = e.target.value || ''
      // 提取负号
      const isNegative = value.charAt(0) === '-'
      // 只保留数字和一个小数点
      value = value.replace(/[^\d.]/g, '')
      // 只允许一个小数点
      value = value.replace(/\.\.+/g, '.')
      value = value.replace(/^\./, '0.')
      let parts = value.split('.')
      if (parts.length > 2) {
        value = parts[0] + '.' + parts.slice(1).join('')
        parts = value.split('.')
      }
      if (parts[1] !== undefined) {
        parts[1] = parts[1].slice(0, 2)
        // 小数第二位不能是0
        if (parts[1].length === 2 && parts[1][1] === '0') {
          parts[1] = parts[1][0]
        }
        value = parts[0] + '.' + parts[1]
      }
      // 恢复负号
      if (isNegative) {
        value = '-' + value
      }
      if (value !== e.target.value) {
        input.value = value
        input.dispatchEvent(new Event('input'))
      }
    }
    input.addEventListener('input', handler)
    el._currencyInputHandler = handler
  },
  unbind(el) {
    const input = el.querySelector('input')
    if (input && el._currencyInputHandler) {
      input.removeEventListener('input', el._currencyInputHandler)
      delete el._currencyInputHandler
    }
  }
}

export default currencyInput



// WEBPACK FOOTER //
// ./src/directive/currencyInput.js